'use client';

var DEFAULT_ALLOW_FILES_EXT = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];
var DEFAULT_ALLOW_EXT = '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';
var DEFAULT_1MB_SIZE = 1000000;
var DEFAULT_1KB_SIZE = 1000;
var DEFAULT_LIMIT_FILE_SIZE = 5242880; // 5MB - update theo size backend validate
var DEFAULT_SUCCESS_CODE = 200;
var DEFAULT_MAX_LENGTH_JOB_TITLE = 80;
var MIN_YEAR_OF_EXPERIENCE = 0;
var MAX_YEAR_OF_EXPERIENCE = 99;
var MIN_SALARY = 0;
var MAX_SALARY = 500000;
var noSpecialCharsForJobTitle = /[@!$%^*()_|~=`{}[\]:";'<>?,]/;
var META_API_LINK = "/meta/v1.0/international-phone-number";
var INTERNSHIP_ID = 8;
var FRESHER_ID = 1;
var LITMIT_SELECTION = 3;
var DEFAULT_MAX_SUMMARY_LENGTH = 5000; // Max 5000 characters for summary field in my-profile
var defaultProps = {
    initialData: {
        address: '',
        birthday: new Date(1990, 0, 1),
        cityId: 0,
        countryId: 0,
        districtId: 0,
        email: '',
        genderId: 0,
        isSearchable: false,
        maritalStatusId: 0,
        nationalityId: 0,
        phone: '',
        userId: 0,
        resumeId: 0
    },
    onCancel: function () { return null; },
    onSave: function () { return null; }
};
var initWorkingReferenceData = {
    jobTitle: '',
    jobLevelId: 0,
    locations: [],
    industries: [],
    companyIndustries: [],
    salary: 0,
    isSearchable: 0,
    yearsExperience: 0,
    highestDegreeId: 0,
    resumeId: -1,
    jobFunction: []
};
var INTERNATIONAL_CITY_ID = 70;
var MEKONG_CITY_ID = 71;
var OTHER_CITY_ID = 66;
var VIETNAM_COUNTRY_ID = 1;
var notAllowCityId = [INTERNATIONAL_CITY_ID, MEKONG_CITY_ID, OTHER_CITY_ID];

export { DEFAULT_1KB_SIZE, DEFAULT_1MB_SIZE, DEFAULT_ALLOW_EXT, DEFAULT_ALLOW_FILES_EXT, DEFAULT_LIMIT_FILE_SIZE, DEFAULT_MAX_LENGTH_JOB_TITLE, DEFAULT_MAX_SUMMARY_LENGTH, DEFAULT_SUCCESS_CODE, FRESHER_ID, INTERNATIONAL_CITY_ID, INTERNSHIP_ID, LITMIT_SELECTION, MAX_SALARY, MAX_YEAR_OF_EXPERIENCE, MEKONG_CITY_ID, META_API_LINK, MIN_SALARY, MIN_YEAR_OF_EXPERIENCE, OTHER_CITY_ID, VIETNAM_COUNTRY_ID, defaultProps, initWorkingReferenceData, noSpecialCharsForJobTitle, notAllowCityId };
//# sourceMappingURL=constants.js.map
